import { useQuery } from '@tanstack/react-query';

import type { ExtranetRoom } from 'app/typings/packages';
import { apiRequest } from 'app/utils/request/api';

const path = '/extranet/:hotelId/rooms' as const;

export type HotelExtranetRooms = {
  rooms: ExtranetRoom[];
};
export function useRoomsByHotelId(hotelId: number) {
  return useQuery<HotelExtranetRooms>({
    queryKey: [path, { hotelId }],
    queryFn: () =>
      apiRequest({
        path: path,
        params: { hotelId: hotelId.toString() },
      }),
    staleTime: Infinity,
  });
}
